import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=ccb23736&"
import script from "./Activate.vue?vue&type=script&lang=js&"
export * from "./Activate.vue?vue&type=script&lang=js&"
import style0 from "./Register.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCard,VSpacer})
